/* eslint-disable @typescript-eslint/no-explicit-any */
import { toast } from "@/hooks/use-toast";
import { apiServices } from "@/services/api.services";
import { PRESIGNED_URL } from "@/services/global.services";
import { getUserInfo } from "./token";

export const getFileUrl = async (url: any) => {
  const tempUserData = getUserInfo();

  const payload = {
    file_path: url?.file || url,
    company_id: tempUserData?.company_id,
    user_id: tempUserData?.user_id,
  };
  const { data, error, message } = await apiServices<any>(
    PRESIGNED_URL.get,
    "post",
    payload
  );

  // console.log({ data: data, error, message });
  // console.log({ data: data.metadata.presigned_url_get, error, message });

  if (error) {
    toast({
      title: "Error",
      variant: "destructive",
      description: error.status?.message || message,
    });
  }
  if (data?.result?.metadata?.presigned_url_get) {
    return data.result.metadata.presigned_url_get;
  }
  if (data?.metadata?.presigned_url_get) {
    return data.metadata.presigned_url_get;
  }
  return { data, error };
};
